module.exports = __webpack_public_path__ + "img/product-img3.0c312683.png";